import { useEffect } from 'react';

import { getMobileStoreLink } from 'commons/utils/links';

const Download = () => {
  useEffect(() => {
    window.location.href = getMobileStoreLink();
  }, []);

  return null;
};

export default Download;
